<!-- eslint-disable max-len -->
<style scoped>
  .checkbox-hidden {
    display: none;
  }
  .project-goals-label {
    font-weight:normal;
  }
</style>
<template>
  <div class="view-contents" v-if="isAdmin">
    <div class="row title-row">
      <div class="col section-title">
        Targets, Objectives, and Goals Management
        <b-button
          variant="primary"
          :class="['tog-top-button', 'action-button', seletedButton !='removeBtn' ? 'tog-top-button-inactive' : '']"
          id="removeBtn"
          @click="selectRemove"
        >
          <span>Remove</span>
        </b-button>
        <b-button
          variant="primary"
          :class="['tog-top-button', 'action-button', seletedButton !='editBtn' ? 'tog-top-button-inactive' : '']"
          id="editBtn"
          @click="$router.push('EditTOG')"
        >
          <span>Edit</span>
        </b-button>
        <b-button
          variant="primary"
          :class="['tog-top-button', 'action-button', seletedButton !='addBtn' ? 'tog-top-button-inactive' : '']"
          id="addBtn"
          @click="$router.push('AddTOG')"
        >
          <span>Add</span>
        </b-button>
      </div>
    </div>
    <div class="section-header">
    </div>
    <div class="section-header">
      <b-overlay :show="projectObjectivesLoading">
        <div class="tog-sub-header">
            <div v-if="isRemoveSeleted">
              Please select which Target, Objective, or Goal you would like to remove.
            </div>
            <div>
            <b-button
              v-if="isRemoveSeleted" pill variant="primary" size="sm"
              class="submit-form-button btn-danger"
              :disabled="!isItemToRemoveSelected"
              v-b-modal="'removeTOGItemModal'">
              <b-modal id="removeTOGItemModal" @ok="onDeleteTOGItmeOkClick()">
                <template v-slot:modal-title>
                  <span class='project-modal-warning'>Remove selected Item</span>
                </template>
                <p>Are you sure you want to permanently delete "{{this.selectedItemName}}" {{this.selectedItemCat}}? This will no longer be an option for future projects.</p>
                <template v-slot:modal-footer="{ ok, cancel }">
                  <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
                  <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
                </template>
              </b-modal>
              <span>Delete</span>
            </b-button>
            <b-button v-if="isRemoveSeleted"
              pill variant="danger" size="sm"
              class="submit-form-button btn-danger"
              @click="cancelRemove">
              <span>Cancel</span>
            </b-button>
            </div>
        </div>
        <div class="row bold-title">
          <div class="col">
            <span>Targets</span>
          </div>
          <div class="col">
            <span>Objectives</span>
          </div>
          <div class="col">
            <span>Goals</span>
          </div>
        </div>
        <div>
          <div class="row" v-if="!isRemoveSeleted">
            <div class="col site-section-wrapper">
              <div class="card card-body tog-list">
                <ul>
                  <li v-for="item in projectAccomplishmentTargets" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col site-section-wrapper">
              <div class="card card-body tog-list">
                <ul>
                  <li v-for="item in projectObjectives" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col site-section-wrapper">
              <div class="card card-body tog-list">
                <ul>
                  <li v-for="item in projectGoals" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row" v-if="isRemoveSeleted">
            <div class="col site-section-wrapper">
              <div class="card card-body tog-list">
                <b-form-group>
                  <b-form-checkbox-group v-model='projectAccomplishmentTargetsSelected' name='projectAccomplishmentTargets' class='tog-remove'>
                    <b-form-checkbox
                    :disabled="isItemToRemoveSelected && selectedItem != 'T-' + item.id"
                    @change='itemToRemove("T-" + item.id)'
                    v-for="item in projectAccomplishmentTargets"
                    :id="'T-' + item.id"
                    :key="item.id"
                    :value="item.id">
                      <span class='project-goals-label'>{{ item.name }}</span>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
            <div class="col site-section-wrapper">
              <div class="card card-body tog-list">
                <b-form-group>
                  <b-form-checkbox-group v-model='projectObjectivesSelected' name='projectObjectives' class='tog-remove'>
                    <b-form-checkbox
                    :disabled="isItemToRemoveSelected && selectedItem != 'O-' + item.id"
                    class="tog-checkbox-label"
                    @change='itemToRemove("O-" + item.id)'
                    v-for="item in projectObjectives"
                    :id="'O-' + item.id"
                    :key="item.id"
                    :value="item.id">
                      <span class='project-goals-label'>{{ item.name }}</span>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
            <div class="col site-section-wrapper">
              <div class="card card-body tog-list">
                <b-form-group>
                  <b-form-checkbox-group v-model='projectGoalsSelected' name='projectGoals' class='tog-remove'>
                    <b-form-checkbox
                    :disabled="isItemToRemoveSelected && selectedItem != 'G-' + item.id"
                    @change='itemToRemove("G-" + item.id)'
                    v-for="item in projectGoals"
                    :id="'G-' + item.id"
                    :key="item.id"
                    :value="item.id">
                      <span class='project-goals-label'>{{ item.name }}</span>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, no-param-reassign, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import exitFormModal from '@/mixins/exitFormModal';
import TargetObjectiveGoalManager from '@/mixins/targetObjectiveGoalManager';

export default {
  name: 'TOGList',
  mixins: [TargetObjectiveGoalManager, exitFormModal],
  computed: {
    ...mapState(['currentSite', 'config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    ...mapState('Project', {
      project: (state) => state.project,
      projectAccomplishmentTargets: (state) => state.projectAccomplishmentTargets,
      projectGoals: (state) => state.projectGoals,
      projectObjectives: (state) => {
        const objectives = [...state.projectObjectives].sort((a, b) => a.name.localeCompare(b.name));
        objectives.forEach((item) => {
          item.projectObjectiveAccomplishmentTargets.sort(
            (a, b) => a.projectAccomplishmentTarget.name.localeCompare(b.projectAccomplishmentTarget.name),
          );
        });

        return objectives;
      },
      projectObjectiveAccomplishmentTargetSelections: (state) => state.projectObjectiveAccomplishmentTargetSelections,
    }),
    isAdmin() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const viewerRoles = this.config.dashboardPage.adminRoles;
      return this.memberOf.find((item) => viewerRoles.includes(item.displayName));
    },
  },
  data() {
    return {
      projectId: null,
      projectAccomplishmentTargetsSelected: [],
      projectObjectivesLoading: false,
      projectGoalsSelected: [],
      projectObjectivesSelected: [],
      projectAccomplishmentTargetsLoading: true,
      isRemoveSeleted: false,
      seletedButton: null,
      isItemToRemoveSelected: false,
      selectedItem: null,
      selectedItemCat: null,
      selectedItemName: null,
    };
  },
  watch: {
    projectObjectivesSelected(newValues) {

      this.projectAccomplishmentTargetsLoading = true;

      this.projectObjectives.forEach((projectObjective) => {
        if (newValues.includes(projectObjective.id)) {
          projectObjective.childClass = '';
        } else {
          projectObjective.childClass = 'checkbox-hidden';
          projectObjective.projectObjectiveAccomplishmentTargetsSelected = [];
        }
      });

      this.projectAccomplishmentTargetsLoading = false;
    },
  },
  mounted() {
    (async () => {
      await this.load();
    })();
  },
  methods: {
    selectAdd() {
      this.isRemoveSeleted = false;
      this.seletedButton = 'addBtn';
    },
    selectEdit() {
      this.isRemoveSeleted = false;
      this.seletedButton = 'editBtn';
    },
    selectRemove() {
      this.isRemoveSeleted = true;
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
      this.seletedButton = 'removeBtn';
    },
    async cancelRemove() {
      this.isItemToRemoveSelected = false;
      this.seletedButton = null;
      this.selectedItem = null;
      this.selectedItemName = null;
      this.selectedItemCat = null;
      this.isRemoveSeleted = false;
      this.projectAccomplishmentTargetsSelected = [];
      this.projectGoalsSelected = [];
      this.projectObjectivesSelected = [];
    },
    itemToRemove(selId) {
      this.isItemToRemoveSelected = !this.isItemToRemoveSelected;
      const targetCheckbox = document.getElementById(selId);
      if (targetCheckbox.checked) {
        this.selectedItem = selId;
        this.selectedItemName = this.getCheckboxLabelText(targetCheckbox);
        if (selId.startsWith('T-')) {
          this.selectedItemCat = 'target';
        } else if (selId.startsWith('G-')) {
          this.selectedItemCat = 'goal';
        } else if (selId.startsWith('O-')) {
          this.selectedItemCat = 'objective';
        }
      } else {
        this.selectedItem = null;
        this.selectedItemName = null;
        this.selectedItemCat = null;
      }
    },
    getCheckboxLabelText(checkboxElement) {
      if (checkboxElement.id) {
        const label = document.querySelector(`label[for="${checkboxElement.id}"]`);
        return label ? label.textContent : null;
      }
      return null;
    },
    cascadeProjectGoalsSelectedNewValues(newValues) {

      const selectedProjectGoals = this.projectGoals.filter((projectGoal) => newValues.includes(projectGoal.id));
      const selectedProjectGoalObjectiveIds = this.getDistinctProjectObjectiveIds(selectedProjectGoals);
      const unselectedProjectGoals = this.projectGoals.filter((projectGoal) => !newValues.includes(projectGoal.id));
      const unselectedProjectGoalObjectiveIds = this.getDistinctProjectObjectiveIds(unselectedProjectGoals);
      const removableProjectGoalObjectiveIds = [];

      unselectedProjectGoalObjectiveIds.forEach((projectObjectiveId) => {
        if (!selectedProjectGoalObjectiveIds.includes(projectObjectiveId)) {
          removableProjectGoalObjectiveIds.push(projectObjectiveId);
        }
      });

      removableProjectGoalObjectiveIds.forEach((projectObjectiveId) => {
        if (this.projectObjectivesSelected.includes(projectObjectiveId)) {
          const index = this.projectObjectivesSelected.indexOf(projectObjectiveId);
          this.projectObjectivesSelected.splice(index, 1);
        }
      });
    },
    getDistinctProjectObjectiveIds(projectGoals) {

      const ids = [];

      projectGoals.forEach((projectGoal) => {
        projectGoal.projectGoalObjectives.forEach((projectGoalObjective) => {
          if (!ids.includes(projectGoalObjective.projectObjectiveId)) {
            ids.push(projectGoalObjective.projectObjectiveId);
          }
        });
      });

      return ids.sort();
    },
    async load() {
      this.projectObjectivesLoading = true;
      this.seletedButton = null;
      await this.$store.dispatch('Project/getValidProjectGoalsAsync');
      await this.$store.dispatch('Project/getValidProjectAccomplishmentTargetsAsync');
      await this.$store.dispatch('Project/getValidProjectObjectivesAsync');

      this.projectGoals.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      this.projectObjectives.forEach((projectObjective) => {

        projectObjective.class = 'checkbox-hidden';

        projectObjective.projectObjectiveAccomplishmentTargetsSelected = this.projectObjectiveAccomplishmentTargetSelections.filter(
          (e) => e.projectObjectiveId === projectObjective.id,
        ).map(
          (e) => `${e.projectObjectiveId}|${e.projectAccomplishmentTargetId}`,
        );

        projectObjective.projectObjectiveAccomplishmentTargets.forEach((projectObjectiveAccomplishmentTarget) => {
          projectObjectiveAccomplishmentTarget.class = 'checkbox-hidden';
          projectObjectiveAccomplishmentTarget.childClass = 'checkbox-hidden';
        });

      });

      this.projectObjectivesLoading = false;
    },
  },
};
</script>
